import store from "@/store/index";
import moment from "moment";


const corporateRoutes = {
  path: "/corporate",
  component: () => import("@/layouts/AuthorizedCorporateLayout.vue"),
  children: [
    {
      path: "corp-start",
      name: "corp-start",
      component: () => import("@/views/corporate/Start.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        next: "corp-general-data",
      },
    },
    {
      path: "corp-general-data",
      name: "corp-general-data",
      component: () => import("@/views/corporate/GeneralData.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "corp-start",
        next: "company-legal",
      },
    },
    {
      path: "company-legal",
      name: "company-legal",
      component: () => import("../views/corporate/CompanyLegal.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.getters.corporateCaseData?.companyInfo.hrRegistered) {
          if (from.meta.next === to.name) {
            next({ name: to.meta.next});
          } else {
            next({ name: to.meta.previous })
          }
        } else {
          next();
        }
      },
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        dependsOnField: () => store.getters.corporateCaseData?.companyInfo.hrRegistered,
        dependsOnValue: false,
        previous: "corp-general-data",
        next: "accounting",
      },
    },
    {
      path: "accounting",
      name: "accounting",
      component: () => import("@/views/corporate/Accounting.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "company-legal",
        next: "employees",
      },
    },
    // {
    //   path: "tax-declaration",
    //   name: "tax-declaration",
    //   component: () => import("@/views/corporate/TaxDeclaration.vue"),
    //   meta: {
    //     requiresAuth: true,
    //     requiresInternalValidation: false,
    //     previous: "accounting",
    //     next: "employees",
    //   },
    // },
    {
      path: "employees",
      name: "employees",
      component: () => import("@/views/corporate/Employees.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "accounting",
        next: "social-insurance",
      },
    },
    {
      path: "social-insurance",
      name: "social-insurance",
      component: () => import("@/views/corporate/SocialInsurance.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "employees",
        next: "fixed-assets",
      },
    },
    {
      path: "fixed-assets",
      name: "fixed-assets",
      component: () => import("@/views/corporate/FixedAssets.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "social-insurance",
        next: 'working-capital',
      },
    },
    {
      path: "working-capital",
      name: "working-capital",
      component: () => import("@/views/corporate/WorkingCapital.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "fixed-assets",
        next: 'banks',
      },
    },
    {
      path: "banks",
      name: "banks",
      component: () => import("@/views/corporate/Banks.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "working-capital",
        next: 'corp-cloud',
        pageTitlei18nData: () => { return { date: moment(store.getters.corporateCaseData?.insFilingDate).format('DD.MM.YYYY') }}
      },
    },
    {
      path: "corp-cloud",
      name: "corp-cloud",
      component: () => import("@/views/corporate/Cloud.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "banks",
        next: 'corp-overview',
      },
    },
    {
      path: "overview",
      name: "corp-overview",
      component: () => import("@/views/corporate/OverviewV2.vue"),
      meta: {
        requiresAuth: true,
        requiresInternalValidation: false,
        previous: "corp-cloud",
        next: null,
      },
    }
  ],
  meta: {
    requiresAuth: true,
    role: "corp_debtor",
  },
};

export { corporateRoutes };
